import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_COUPON_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.SAVE_COUPON_SUCCESS: {
      return {
        ...state,
        data: action.response,
        isProgress: false,
      };
    }
    case homeConstants.SAVE_COUPON_FAILURE:
      return {
        ...state,
        error: action.error,
        data: {},
        isProgress: false,
      };
    case homeConstants.RESET_SAVED_COUPON_INFO:
      return {
        ...state,
        error: action.error,
        data: {},
        isProgress: false,
      };
    default:
      return state;
  }
}
